import { Environment } from '@shared/interfaces/environment';
import { RoutesPath } from '@shared/enums/routes-path';
import { ServiceDetailRoutesPath } from '@odoscanner/pages/services/enums/service-detail-routes-path';
import { ArticleDetailRoutesPath } from '@odoscanner/pages/articles/enums/article-detail-routes-path';
import { GlobalRoutesPath } from '@shared/enums/global-routes-path';

export const environment: Environment = {
  production: true,
  langs: {
    fr: {
      host: 'odoscanner.com',
      langs: ['fr'],
      defaultLang: 'fr',
      countryCode: ['fr'],
      plate: {
        code: 'f',
        placeholder: 'AB-123-CD',
      },
      api: {
        url: 'https://api.odoscanner.com',
      },
      google: {
        maps: {
          apiKey: 'AIzaSyD3x-BEC9uo0V3zMtXRg1vC42iRJubvM8Q',
        },
      },
      sentry: {
        dsn: 'https://c14247525a3692036533e4d3c13f3d3a@o4508637161783296.ingest.de.sentry.io/4508698687504464',
      },
      config: {
        name: 'Odoscanner',
        test: false,
        subscription: {
          name: 'Odoscanner Pro',
          prices: {
            fixed: 0.99,
            subscription: 49.99,
          },
          credit: 15,
        },
        advices: [
          {
            rate: 4.7,
            vote: 2254,
          },
        ],
        company: {
          rcs: '207787211',
          vat: 'BG207787211',
          address: 'Jawaharlal Neru n.28, Silver Center, fl.2, office 64. 1324 Sofia, Bulgaria',
          name: 'INOVATECH SOLUTIONS LTD',
        },
        partners: [
          {
            name: 'techcars',
            logo: '/assets/img/partners/partner-1.png',
          },
          {
            name: 'turbauto',
            logo: '/assets/img/partners/partner-2.png',
          },
          {
            name: 'roadup',
            logo: '/assets/img/partners/partner-3.png',
          },
          {
            name: 'autogo',
            logo: '/assets/img/partners/partner-4.png',
          },
        ],
        payment: {
          logo: '/assets/favicon.png',
        },
      },
      routes: {
        [RoutesPath.SIGN_IN]: 'se-connecter',
        [RoutesPath.SIGN_UP]: 'creer-compte',
        [RoutesPath.UNSUBSCRIBE]: 'se-desabonner',
        [RoutesPath.FORGOT_PASSWORD]: 'recuperer-mot-de-passe',
        [RoutesPath.RESET_PASSWORD]: 'reset-password',
        [RoutesPath.CONTACT]: 'support-client',
        [RoutesPath.SERVICES]: 'liste-services',
        [RoutesPath.ARTICLES]: 'nouvelles',
        [RoutesPath.LANDINGS]: 'landings/car-history',
        [RoutesPath.DASHBOARD]: 'espace-utilisateur',
        [RoutesPath.NOT_FOUND]: 'page-non-trouvee',
        [RoutesPath.ABOUT]: 'notre-entreprise',
        [RoutesPath.PREVIEW]: 'demonstration',
        [RoutesPath.PAYMENT_INTENT]: 'paiement-previsionnel',
        [RoutesPath.PAYMENT_VALIDATION]: 'validation-du-paiement',
        [RoutesPath.LOADING]: 'en-chargement',
        [RoutesPath.LOADING_PREVIEW]: 'chargement-apercu',
        [RoutesPath.PRICING]: 'plans-et-tarifs',
        [RoutesPath.TESTIMONIALS]: 'avis-clients',
        [RoutesPath.SERVICE]: 'details-service',
        [RoutesPath.SSO]: 'autosign',
        [RoutesPath.CAR_NOT_FOUND]: 'voiture-non-trouvee',
        [RoutesPath.VIN]: '',
        [RoutesPath.COMPARE]: '',
        [RoutesPath.PARTNERS]: '',
        [RoutesPath.GLOSSARY]: '',
        [RoutesPath.COMPANY]: '',
        [RoutesPath.AFFILIATE]: '',
        [RoutesPath.LEASING]: '',
        [RoutesPath.INSURANCE]: '',
        [RoutesPath.CAREERS]: '',
        [RoutesPath.GUIDE]: '',
        [RoutesPath.PRESS]: '',
      },
      globalRoutes: {
        [GlobalRoutesPath.LEGAL_NOTICE]: 'mentions-legales',
        [GlobalRoutesPath.PRIVACY_POLICY]: 'politique-de-confidentialite',
        [GlobalRoutesPath.REFUND_POLICY]: 'politique-de-remboursement',
        [GlobalRoutesPath.TERMS_AND_CONDITIONS]: 'conditions-generales',
        [GlobalRoutesPath.TERMS_OF_SALES]: 'conditions-generales-de-vente',
        [GlobalRoutesPath.FREQUENTLY_ASKED_QUESTIONS]: 'faq',
      },
      serviceRoutes: {
        [ServiceDetailRoutesPath.OBTENIR_L_HISTORIQUE_D_UN_VEHICULE]: 'obtenir-l-historique-d-un-vehicule',
        [ServiceDetailRoutesPath.ESTIMER_LE_PRIX_DE_VOTRE_VEHICULE]: 'estimer-le-prix-de-votre-vehicule',
        [ServiceDetailRoutesPath.ANALYSER_LE_KILOMETRAGE_D_UN_VEHICULE]: 'analyser-le-kilometrage-d-un-vehicule',
      },
      articleRoutes: {
        [ArticleDetailRoutesPath.LES_ERREURS_COURANTES_A_EVITER_LORS_DE_L_ACHAT_D_UNE_VOITURE_D_OCCASION]:
          'les-erreurs-courantes-a-eviter-lors-de-l-achat-d-une-voiture-d-occasion',
        [ArticleDetailRoutesPath.LES_SECRETS_POUR_ECONOMISER_DE_L_ARGENT_SUR_VOTRE_ASSURANCE_AUTO]:
          'les-secrets-pour-economiser-de-l-argent-sur-votre-assurance-auto',
        [ArticleDetailRoutesPath.LES_DEFIS_ET_OPPORTUNITES_DE_LA_CONDUITE_AUTONOME]:
          'les-defis-et-opportunites-de-la-conduite-autonome',
        [ArticleDetailRoutesPath.GUIDE_ULTIME_DE_L_ENTRETIEN_PREVENTIF_DE_VOTRE_VOITURE]:
          'guide-ultime-de-l-entretien-preventif-de-votre-voiture',
        [ArticleDetailRoutesPath.LES_VOITURES_LES_PLUS_ECONOMES_EN_CARBURANT_SUR_LE_MARCHE]:
          'les-voitures-les-plus-economes-en-carburant-sur-le-marche',
        [ArticleDetailRoutesPath.LES_VOITURES_HYBRIDES_POURQUOI_DEVRIEZ_VOUS_ENVISAGER_CE_CHOIX_ECOLOGIQUE]:
          'les-voitures-hybrides-pourquoi-devriez-vous-envisager-ce-choix-ecologique',
      },
    },
  },
};
